// Map and Main content area functionality
export const setupCustomerInsightsMap = () => {
    const stateToRegionMap = {
        WA: "west", OR: "west", CA: "west", NV: "west", ID: "west", MT: "west", UT: "west", CO: "west", WY: "west", AK: "west", HI: "west", NM: "west", AZ: "west",
        ND: "midwest", SD: "midwest", NE: "midwest", KS: "midwest", MN: "midwest", IA: "midwest", MO: "midwest", WI: "midwest", IL: "midwest", IN: "midwest", OH: "midwest", MI: "midwest",
        TX: "south", OK: "south", AR: "south", LA: "south", MS: "south", AL: "south", GA: "south", FL: "south", SC: "south", NC: "south", VA: "south", TN: "south", KY: "south", WV: "south", DC: "south", DE: "south", MD: "south",
        PA: "northeast", NJ: "northeast", NY: "northeast", CT: "northeast", RI: "northeast", MA: "northeast", VT: "northeast", NH: "northeast", ME: "northeast"
    };

    const svg = document.querySelector(".us-map-svg");
    const states = svg.querySelectorAll("path[data-state]");
    const overlay = document.getElementById("mapOverlay");
    const wrapper = document.querySelector(".customer-insights-wrapper");

    let currentMonth = wrapper?.getAttribute("data-current-month");
    const insightData = window.insight_questions_data || {};

    const colors = {
        nationwide: "#2d95e5",
        grey: "#dff0f7",
        regionFills: {
            west: "#FFD039",
            midwest: "#FC8D28",
            south: "#EB6343",
            northeast: "#2862a4"
        }
    };

    const uc = str => str[0].toUpperCase() + str.slice(1);

    const assignRegionToMap = () => {
        states.forEach(path => {
            const st = path.getAttribute('data-state');
            const region = stateToRegionMap[st];
            if (region) path.setAttribute('data-region', region);
        });
    };

    const updateQuestionNumbersColor = (color) => {
        document.querySelectorAll('.question-number').forEach(el => {
            el.style.color = color;
        });
    };

    const renderQuestions = (regionKey, color) => {
        const main = document.querySelector(".customer-insights-main");
        main.innerHTML = '';

        const allQuestions = insightData[currentMonth]?.questions || [];

        allQuestions.forEach((q, index) => {
            const regionMatch = (q.region_responses || []).find(r => r.region === regionKey);
            if (!regionMatch || !regionMatch.region_data?.length) return;

            const block = document.createElement("div");
            block.className = "question-block";

            const header = document.createElement("p");
            header.className = "survey-question";
            header.innerHTML = `<span class="question-number">${index + 1}</span> ${q.question_text}`;
            block.appendChild(header);

            regionMatch.region_data.forEach(item => {
                const label = item.response_label || "—";
                const percentValue = parseFloat(item.response_percentage) || 0;

                const outer = document.createElement("div");
                outer.className = "response-item";

                const labelRow = document.createElement("div");
                labelRow.className = "label-row";
                labelRow.innerHTML = `
                    <div class="label-text">${label}</div>
                    <div class="percent-badge">${percentValue.toFixed(1)}%</div>
                `;

                const barContainer = document.createElement("div");
                barContainer.className = "bar-container";
                const barFill = document.createElement("div");
                barFill.className = "bar-fill";
                barFill.style.width = `${percentValue}%`;

                barContainer.appendChild(barFill);
                outer.appendChild(labelRow);
                outer.appendChild(barContainer);
                block.appendChild(outer);
            });

            main.appendChild(block);
        });

        updateQuestionNumbersColor(color);
    };

    const applyRegion = (regionKey) => {
        const region = uc(regionKey);
        const fillColor = regionKey === 'nationwide' ? colors.nationwide : colors.regionFills[regionKey];

        if (overlay) overlay.style.display = regionKey === 'nationwide' ? 'block' : 'none';

        states.forEach(s => {
            const isMatch = s.getAttribute("data-region") === regionKey;
            s.setAttribute("fill", isMatch || regionKey === 'nationwide' ? fillColor : colors.grey);
            s.classList.toggle("faded", !isMatch && regionKey !== 'nationwide');
        });

        const regionNameLabel = document.querySelector(".map-title .region-name");
        if (regionNameLabel) {
            regionNameLabel.textContent = uc(regionKey);
            const allRegionClasses = ["region-nationwide", "region-west", "region-midwest", "region-south", "region-northeast"];
            regionNameLabel.classList.remove(...allRegionClasses);
            regionNameLabel.classList.add(`region-${regionKey}`);
        }



        renderQuestions(region, fillColor);
    };

    assignRegionToMap();
    applyRegion("nationwide");

    states.forEach(state => {
        state.addEventListener("click", () => {
            const regionKey = state.getAttribute("data-region");
            applyRegion(regionKey);
        });
    });

    const btn = document.getElementById("nationwide-button");
    if (btn) btn.addEventListener("click", () => applyRegion("nationwide"));

    // Store reference for date picker access
    window.__applyCustomerInsightsRegion = applyRegion;
    window.__updateCurrentMonth = (month) => {
        currentMonth = month;
    };
};

// Date picker for Customer Insights
export const setupCustomerInsightsDatePicker = () => {
    const dropdown = document.getElementById("customer-insights");
    const wrapper = document.querySelector(".customer-insights-wrapper");
    if (!dropdown || !wrapper || !window.insight_questions_data) return;

    const data = window.insight_questions_data;
    const currentMonth = wrapper.getAttribute("data-current-month");

    Object.entries(data)
        .sort(([a], [b]) => b.localeCompare(a)) // newest to oldest
        .forEach(([monthKey, { label }]) => {
            const option = document.createElement("option");
            option.value = monthKey;
            option.textContent = label;
            if (monthKey === currentMonth) option.selected = true;
            dropdown.appendChild(option);
        });


    dropdown.addEventListener("change", (e) => {
        const selectedMonth = e.target.value;
        if (!data[selectedMonth]) return;

        wrapper.setAttribute("data-current-month", selectedMonth);
        window.__updateCurrentMonth?.(selectedMonth);
        window.__applyCustomerInsightsRegion?.("nationwide");

        // ✅ Update the post title
        const title = document.querySelector(".customer-insight-title");
        if (title) {
            title.textContent = `Customer Insights ${data[selectedMonth].label}`;
        }
    });
};
